export async function multiUpload() {
    let multiUploads = document.querySelectorAll('.multiupload');

    if (multiUploads.length) {
        let { initMultiUpload } = await import(/* webpackMode: "lazy" */ './inc/multiupload.async.js');

        initMultiUpload(multiUploads);
    }
}
